module.exports = __webpack_public_path__ + "static/website-b36782e13699e310fa902aee72c97d6a.png";